import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Layout from './Components/Layout components/Layout.js';
import AllFolders from './Components/Folder System/AllFolders.jsx';
import SubFolderDetails from './Components/Folder System/SubFolderDetails.jsx';
import { useState } from 'react';
import EventList from './Components/EventList.jsx';
import HomePage from "./Components/HomePage/HomePage.jsx";
import Register from "./Components/Register.js";
import FolderUpload from './Components/Folder System/FolderUpload.js';
import VendorProfile from './Components/VendorProfile.js';
import Transactions from './Components/Transactions/Transactions.jsx';
import Portfolio from './Components/Portfolio/Portfolio.jsx';

const isAuthenticated = () => Boolean(localStorage.getItem('vendorId'));

// Redirect logged-in users away from login/register
const PublicRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) =>
    isAuthenticated() ? <Redirect to="/eventlist" /> : <Component {...props} />
  } />
);

// Redirect guests to login
const PrivateRoute = ({ component: Component, render, ...rest }) => (
  <Route {...rest} render={(props) =>
    isAuthenticated()
      ? (render ? render(props) : <Component {...props} />)
      : <Redirect to="/" />
  } />
);

function App() {

  const [logoFile, setLogoFile] = useState(null);
  const [watermarkFile, setWatermarkFile] = useState(null);
  const [eventId, setEventId] = useState("");
  const [userId, setUserId] = useState("");

  useEffect(() => {
    // Push an extra entry so the browser has somewhere "safe" to pop to
    window.history.pushState(null, '', window.location.href);

    const handlePopState = () => {
      // Allow navigation triggered by our own back-arrow buttons
      if (window.__appAllowBack) {
        window.__appAllowBack = false;
        return;
      }
      // Block browser back/forward button
      window.history.pushState(null, '', window.location.href);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  
  // NOTE: must use render prop (not component prop) so React Router
  // doesn't unmount/remount on every App re-render.
  const renderFolderDetails2 = (props) => (
        <FolderUpload
          {...props}
          logoFile={logoFile}
          watermarkFile={watermarkFile}
          eventId={eventId}
          userId={userId}/>);


  const renderSubFolderDetails2 = (props) => (
    <SubFolderDetails 
      {...props} 
      eventId={eventId} 
      userId={userId}/>
  );

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(reg => reg.unregister());
      });
    }
  }, []);

  try {
    const envValue = (typeof process !== 'undefined' && process && process.env && process.env.REACT_APP_ENV) || '';
    if (envValue === "development") {
    } else if (envValue === "production") {
    }
  } catch (_) {
    // Swallow any environment access errors in browser
  }
  
  return (
    <Router>
      <Switch>
        <PublicRoute exact path="/" component={HomePage} />
        <PublicRoute path="/register" component={Register} />
        <PrivateRoute path="/profile" component={VendorProfile} />
        <PrivateRoute path="/transactions" component={Transactions} />
        <PrivateRoute path="/portfolio" component={Portfolio} />
        <Route
          render={() => (
            isAuthenticated() ? (
              <Layout
                logo={logoFile}
                setLogoFile={setLogoFile}
                watermark={watermarkFile}
                setWatermarkFile={setWatermarkFile}
                setEventId={setEventId}
                setUserId={setUserId}>
                <Switch>
                  <PrivateRoute exact path="/eventlist" render={(props) => (
                    <EventList {...props} eventId={eventId} userId={userId} />
                  )} />
                  <PrivateRoute exact path="/folders" component={AllFolders} />
                  <PrivateRoute exact path="/folders/:id/:subFolder" render={renderSubFolderDetails2} />
                  <PrivateRoute exact path="/folders/:id" render={renderFolderDetails2} />
                  <Route render={() => <h1>404 - Page Not Found</h1>} />
                </Switch>
              </Layout>
            ) : <Redirect to="/" />
          )}
        />
      </Switch>
    </Router>
  );
}

export default App;